import { memo } from "react";
import { Tabs } from "ui/components/Tabs";
import { AlertsWidgetProps } from "./types";
import AlertsStatsTab from "./components/AlertsStatsTab/AlertsStatsTab";
import AlertsSearchTab from "./components/AlertsSearchTab/AlertsSearchTab";

const AlertsWidget: React.FC<AlertsWidgetProps> = () => {
  return (
    <Tabs
      tabs={[
        { label: "Statistika", content: <AlertsStatsTab /> },
        { label: "Pretraga", content: <AlertsSearchTab /> },
      ]}
    />
  );
};

export default memo(AlertsWidget);
